/** The check-in dialog's heading: the workshop line and the close button. */
export function CheckInHeader({ title, onClose }: { title: string; onClose: () => void }) {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        gap: 12,
      }}
    >
      <div>
        <h3 style={{ margin: 0, fontSize: 13, letterSpacing: '.06em', color: 'var(--nb-subtle)' }}>
          CHECK IN
        </h3>
        <div style={{ fontSize: 13.5, fontWeight: 600, color: 'var(--nb-ink)', marginTop: 2 }}>
          {title}
        </div>
      </div>
      <button type="button" className="nb-btn nb-btn-ghost" aria-label="Close" onClick={onClose}>
        ×
      </button>
    </div>
  );
}
